<template>
  <div class="card-account-group">
    <div class="illustration-container">
      <img v-if="illustrationUrl" :src="illustrationUrl" :alt="cardTitle" class="illustration" />
    </div>

    <div class="card-content">
      <div class="card-title">
        {{ cardTitle }}
      </div>

      <div class="card-footer">
        <div class="amount">
          {{ formattedAmount }}
        </div>

        <div class="account-avatars">
          <div
            v-for="(avatar, index) in accountAvatars"
            :key="index"
            class="avatar"
          >
            <img :src="avatar.url" :alt="avatar.alt" class="avatar-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardAccountGroup',
  props: {
    cardTitle: {
      type: String,
      required: true,
      description: 'Title of the card (e.g., "Investments")'
    },
    amount: {
      type: Number,
      required: true,
      description: 'The amount to display'
    },
    formatter: {
      type: Object,
      required: true,
      description: 'Formatter object with format method (e.g., {format: v => "£" + v.toLocaleString()})'
    },
    illustrationUrl: {
      type: String,
      required: true,
      description: 'URL for the illustration/background image'
    },
    accountAvatars: {
      type: Array,
      required: true,
      description: 'Array of avatar objects with url and alt properties',
      validator: function(value) {
        return value.every(avatar =>
          typeof avatar.url === 'string' &&
          typeof avatar.alt === 'string'
        );
      }
    },
    backgroundColor: {
      type: String,
      default: '#fce5d4',
      description: 'Background color of the illustration container'
    }
  },
  computed: {
    formattedAmount() {
      return this.formatter.format(this.amount);
    }
  }
}
</script>

<style scoped>
.card-account-group {
  background: linear-gradient(202deg, #FCE5D4 49.85%, #E0C5C8 100%);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.1);
  max-width: 160px;
  display: flex;
  flex-direction: column;
}

.illustration-container {
  background-color: v-bind(backgroundColor);
  height: 90px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.illustration {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.card-content {
  backdrop-filter: blur(7.5px);
  background: rgba(255, 255, 255, 0.95);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card-title {
  font-family: 'Gotham', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  color: #392a4e;
  text-align: center;
  padding: 4px 0;
}

.card-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 4px;
  height: 16px;
}

.amount {
  font-family: 'Gotham', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #392a4e;
  flex: 1;
}

.account-avatars {
  display: flex;
  align-items: center;
  gap: 0;
  padding-right: 8.333px;
}

.avatar {
  width: 16.667px;
  height: 16.667px;
  border-radius: 50%;
  border: 0.417px solid #cccccc;
  overflow: hidden;
  margin-right: -8.333px;
  position: relative;
}

.avatar:last-child {
  margin-right: 0;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
}
</style>
